// extracted by mini-css-extract-plugin
export var left = "Pagination-module--left--qnYw7";
export var pagination = "Pagination-module--pagination--hhon4";
export var right = "Pagination-module--right--MNn7-";